//import { API_VERSION_URL } from '../config';
//import axios from 'axios';


export const getApiVersion=async()=>{
    /*const result=await axios.get(CHECK_VERSION_API_URL);
    return result.data;*/
    return {ApiVersion:1}
}